<template>
    <button
        type="submit"
        class="btn btn-success"
        :disabled="disabled"
    >
        <slot>{{ $t('button.submit') }}</slot>
    </button>
</template>

<script setup lang="ts">
const { disabled = false } = defineProps<{
    disabled?: boolean
}>()
</script>

<style scoped>

</style>
